<template>
  <div class="overall-bg pb-0">
    <!-- <b-container>
      <b-row>
        <b-col>
          <BackToMasters :goback="$router.back"></BackToMasters>
          <Headerlayout :headertext="$t('Request.indenttitle')" :contenttext="$t('Request.contents')"></Headerlayout>
        </b-col>
      </b-row>
    </b-container> -->
  </div>
  <FormLoader v-if="formloader"/>
  <div class="overall-bg pt-0" v-else>
    <b-container class="tab-view">
      <b-form @submit.prevent="IsSubmit">
        <b-row class="stepperdiv">
          <b-col lg="6" md="6" sm="6" cols="2">
          <BackToMasters :goback="$router.back"></BackToMasters>
          <Headerlayout :headertext="$t('Request.indenttitle')" :contenttext="$t('Request.contents')"></Headerlayout>
        </b-col>
          <b-col lg="6" md="6" sm="6" cols="2">
            <Footer class="py-3" :label="SubmitBtnName" :goback="$router.back" />
                  <!-- <AddButton btnname="Save" @click="IsSubmit" />
                  <cancel @canclebtn="$emit('cancel')" /> -->
          </b-col>
        </b-row>
        <b-row class="form-white-bg">

          <RequestId :store-details="storeForm" :IndentFlag="false" codeTitle="indentid" v-model="requestData"
            :EntityId="Entitydata" :UrgentFlag="false" :CategoryHide="false" />
          <b-row>
            <b-col lg="4" sm="12">
              <div class="field">
                <TextField type="text" placeholder="" clearable name="Template Name" id="TemplateName"
                  label="Template Name" v-model="requestForm.TemplateName" :rules="{ required: true }"
                  :requiredIcon="true" :disabled="false" />
              </div>
            </b-col>
          </b-row>

          <div class="transactiontabs">
            <TabView class="tabview-custom" ref="tabview4">
              <TabPanel :class="ItemTab">
                <template #header>
                  <i class="pi pi-align-left pe-3"></i>
                  <span>{{ $t('invtabs.items') }}</span>
                </template>
                <div>
                  <b-row>
                    <b-col class="d-flex flex-row-reverse pb-3">
                      <p class="add-items d-flex d-flex-row-reverse" v-b-toggle.collapse-3>
                        + Add New
                      </p>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-collapse id="collapse-3" :class="displayClass">


                        <Item @additemclick="AddItems" v-model:data-items="dataItems" :show-fields="showFields"
                          :addItemData="items" :commonItemProps="commonItemProps" />

                      </b-collapse>
                    </b-col>
                  </b-row>
                  <Tableview :rowHover="true" filterDisplay="menu" :loading="loading" responsiveLayout="scroll"
                    :columns="headers" v-model:value="items" :row-click="TblIndex" :seriaNlumber="true"
                    @updatedata="Itemschanges">

                    <template v-slot:Brandmodelsize="{ data }">
                      <p><span v-if="data.BrandName">{{ data.BrandName }}</span><span v-if="data.ModelNumberName">/{{
                        data.ModelNumberName }} </span><span v-if="data.SizeName">/{{ data.SizeName }}</span></p>
                    </template>
                    <template v-slot:quantity="{ data, rowIndex }">
                      <div class="label-d-none tablefield mb-0">

                        <TextField type="text" placeholder="" clearable :name="`'quantity'${rowIndex}`"
                          :id="`'quantity'${rowIndex}`" label="" v-model="data.ItemQuantity"
                          :rules="{ required: false, numeric: true }" :requiredIcon="false" :disabled="false"
                          @keyup="LineItemCalculation(data)" />
                      </div>
                    </template>

                    <template v-slot:StockInHand="{ data }">
                      {{
                        data.StockInHand - (data.PickedQty + data.InTransist)
                      }}
                    </template>

                    <template v-slot:action="{ data }">
                      <span class="d-flex align-items-center">
                        <DeleteIcon @click="IsItemDelete(data)" />
                      </span>
                    </template>
                  </Tableview>

                  <b-row>
                    <b-col offset-lg="3" class="d-flex px-0 justify-content-end">
                      <div class="totaldiv1">
                        <p class="component-heading">{{ POCalcDetails.ItemCount }}</p>

                        <p class="light-txt">Items Part of this request</p>
                      </div>
                      <div class="totaldiv2">
                        <p class="component-heading"><span class="pe-1">&#8377</span>{{ POCalcDetails.TotalAmount }}
                        </p>
                        <p class="light-txt mt-3">{{ $t('grn.value') }}</p>
                      </div>
                    </b-col>
                  </b-row>

                
                </div>
              </TabPanel>
            </TabView>
          </div>
        </b-row>
      </b-form>

    </b-container>
  </div>
  <div class="center" v-if="loading">
    <Loader :loading="loading" />
  </div>
  <Toast />
  <CreateSuccessully :visible="popup.successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="popup.updatepop" @ok="closetrigger()" />
  <AddItemConfirmation :Editmodel="AddItemmodel" @yes="CopyReorderData(confirmval)" @no="AddItemmodel = false"
    :content="msgcontent" />
  <WarningMessage :visible="wariningPopup" :content="warningmsgcontent.warningcontent" @ok="ClosewariningPopup()" />

</template>

<script lang="ts">
import BackToMasters from "../../../../../../components/FormComponents/BacktoMaster.vue";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import Badge from "primevue/badge";
import AddItemsVue from  "../../../../../../modules/Inventory/components/Transaction/AddItems.vue";
import {
  defineComponent,
  ref,
  computed,
  reactive,
  onMounted,
  watch,
  onUnmounted
} from "vue";
import Tableview from "../../../../../../components/FormComponents/NormalTable.vue";
import Item from  "../../../../../../modules/Inventory/components/Transaction/Item.vue";
import { useRoute, useRouter } from "vue-router";
import Footer from "../../../../../../components/FormComponents/Footer.vue";
import cancel from "../../../../../../components/GeneralButtons/CancelButtton.vue";
import RequestId from "../../../../../../modules/Inventory/components/Transaction/stockwithoutaffect/RequestId.vue";
import commonService from "../../../../Service/IndentTemplateService";
import CreateSuccessully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AddItemConfirmation from "../../../../../../components/FormComponents/AddItemsConfirmation.vue";
import WarningMessage from "../../../../../../components/FormComponents/WarningMessage.vue";
import RequestPopupVue from  "../../../../../../modules/Inventory/components/Transaction/stockwithoutaffect/RequestPopup.vue";
import CrystalReportPrintPopUp from  "../../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";
import CustomMultiSelect from "../../../../../../components/FormComponents/MultiSelectDropdown.vue";
import { useToast } from "primevue/usetoast";
import moment from "moment";
import ApprovalConfirmation from "../../../../../../components/FormComponents/ApprovalConfirmation.vue";
import ApprovalStatus from "../../../../../../components/FormComponents/ApprovalStatus.vue";
import PoApprovalService from  "../../../../../../modules/Inventory/Service/PoApprovalService";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import { setupHistoryManagement } from  "../../../../../../modules/Inventory/Service/HistoryManage";
import { useForm } from "vee-validate";
import { useI18n } from 'vue-i18n';
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import FormLoader from "../../../../../../components/FormComponents/FormSkeletonLoader.vue"

export default defineComponent({
  components: {
    Loader,
    Badge,
    AddItemsVue,
    Item,
    Tableview,
    Footer,
    cancel,
    BackToMasters,
    Headerlayout,
    RequestId,
    CreateSuccessully,
    UpdatedSuccessfully,
    AddItemConfirmation,
    WarningMessage,
    RequestPopupVue,
    CrystalReportPrintPopUp,
    CustomMultiSelect,
    ApprovalConfirmation,
    ApprovalStatus,
    TextField,
    FormLoader
  },
  props: {
    showone: {
      type: String,
      default: "",
    }
  },
  setup() {
    /* variable declaration*/
    debugger;
    let session: any = localStorage.getItem("UsersData");
    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    const toast = useToast();
    const items: any = ref([]);
    const ReOrderData: any = ref([]);
    const routes = useRoute();
    const router = useRouter();
    let msgcontent = ref({ contentvalue: "" });
    let warningmsgcontent = ref({ warningcontent: "" });
    const confirmval = ref();
    let loading = ref(false);
    let showitemfield = ref(false);
    const display = ref(true);
    const displayClass = ref("show");
    const ItemTab = ref("");
    let arr: any = [];
    const dataItems = ref({});
    const route = useRoute();
    const { handleSubmit, errors } = useForm();
    const { t } = useI18n();
    const formloader=ref(false);
    let SubmitBtnName = ref("Save");

    const CrystalReportPopup = ref(false);
    let ApprovalList = ref([]);
    let ApprovalListchange = ref([]);
    const EditRequestId: any = routes.query.Id;
    const EditDocType = routes.query.Id;
    let StoreId = routes.query.StoreId ?? 0;
    let StoreBrMapId = routes.query.storebranchmapid ?? 0;
    let status = routes.query.status ?? 0;
    let Type = routes.query.Type;
    let OperationId = Number(routes.query.OperationId) ?? 0;
    let Entitydata = ref();
    Entitydata.value = Number(routes.query.EntityId) ?? 0;
    let currentDate = new Date().toISOString().slice(0, 10);
    const AddItemmodel = ref(false);
    const wariningPopup = ref(false);
    const TblIndex = ref(0);
    const selectedProduct: any = ref([]);
    const ColumnVisible = ref(false);
    ColumnVisible.value = status != 1 ? true : false;
    let RequestId = "";
    let SavingArray: any = ref([]);
    let FRequestId = "";
    let FSavingArray: any = ref([]);
    let rolesData;
    let DeptRoleMapId
    let SessionRolesData = localStorage.getItem("RolesData");
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
      DeptRoleMapId = Number(rolesData.DeptRoleMapId);
    }
    let SuccessfullPopUp = ref({
      accept: ref(false),
      decline: ref(false),
    });
    const commonItemProps = ref({
      storeId: Number(StoreId),
      type: 0,
      tostoreId: 0,
      StoreBrMapId: 0,
      FromStoreBrMapId: 0,
      ToStoreBrMapId: 0
    });

    const storeForm = ref({
      // FromStore: Number(StoreId),
      // FromStoreName: "",
      // ToStore: 0,
      // ToStoreName: "",
      // FromStoreCode: "",
      // ToStoreCode: "",
    });

    const fieldData = reactive({
      DocNo: "",
      Remarks: "",
    });

    const POCalcDetails = ref({
      GrossAmount: 0.00,
      ItemCount: 0,
      TotalAmount: 0.00
    })

    const popup = ref({
      successpop: false,
      updatepop: false,
    });

    const requestData = ref({
      DocNo: "",
      Remarks: "",
    });

    const StoreDetailsData = ref({
      StoreId: 0,
    });

    const RequestOPT = ref({
      RequestIds: ref(),
      RequestOption: [],
      FRequestIds: ref(),
      FRequestOption: [],
    });

    let showFields = {
      Category: {
        show: true,
        require: false,
      },
      Name: {
        show: true,
        require: true,
      },
      PackSize: {
        show: false,
        require: false,
      },
      Qty: {
        show: true,
        require: true,
      },
      UnitRate: {
        show: false,
        require: true,
      },
      Brand: {
        show: true,
        require: false,
      },
      ModelNumber: {
        show: true,
        require: false,
      },
      Size: {
        show: true,
        require: false,
      },
      UOM: {
        show: true,
        require: true,
      }
    };

    const requestForm = ref({
      DocType: "21",
      DocNo: "",
      DocDate: currentDate,
      StoreId: 0,
      FromStore: 0,
      ToStore: 0,
      HospitalId: 0,
      BranchId: 0,
      CreatedAt: currentDate,
      Remarks: "",
      Id: 0,
      ModifiedAt: "",
      ModifiedBy: 0,
      CreatedBy: 0,
      EntityId: 0,
      EntityOperationId: 0,
      DeptRoleId: 0,
      StoreBrMapId: 0,
      FromStoreBrMapId: 0,
      ToStoreBrMapId: 0,
      TemplateName: "",
      FromStoreBranchId: 0,
      ToStoreBranchId: 0
    });

    /* variable declaration*/
    const headers = [
      {
        header: t('storetabdetails.indenttemplatecreationtable.Code'),
        field: "ItemProductId",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.indenttemplatecreationtable.Name'),
        field: "Itemname1",
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t('storetabdetails.indenttemplatecreationtable.Brand/Model/Size'),
        field: "",
        slot: "Brandmodelsize",
        fieldDisplay: "false",
      },
      {
        header: t('storetabdetails.indenttemplatecreationtable.AvlQty'),
        field: "StockInHand",
        slot: 'StockInHand',
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
        hide: ColumnVisible.value,
      },
      {
        header: t('storetabdetails.indenttemplatecreationtable.PickedQty'),
        field: "PickedQty",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
        hide: ColumnVisible.value,
      },
      {
        header: t('storetabdetails.indenttemplatecreationtable.InTransist'),
        field: "InTransist",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
        hide: ColumnVisible.value,
      },
      // {
      //   header: "Reorder level",
      //   field: "ReOrderLevel",
      //   bodyclass: "right_td",
      //   class: "smallwidth"
      // },
      {
        header: t('storetabdetails.indenttemplatecreationtable.UOM'),
        field: "UOMName",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.indenttemplatecreationtable.Qty'),
        field: "",
        slot: "quantity",
        bodyclass: "boldclass right_td",
        class: "smallwidth",
        fieldDisplay: "false",
      },
      {
        header: t('storetabdetails.indenttemplatecreationtable.UnitRate'),
        field: "UnitRate",
        bodyclass: "right_td",
        // class: IsApproval.value == 1 ? "smallwidth" : "d-none",
      },
      {
        header: t('storetabdetails.indenttemplatecreationtable.Rate'),
        field: "Rate",
        bodyclass: "right_td",
        // class: IsApproval.value == 1 ? "smallwidth" : "d-none",
      },
      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "last-column-position columnfreeze",
        fieldDisplay: "false",
      },
    ];

    //ReOrder Level Table
    const ReOrderheaders = [
      {
        header: "Id",
        field: "ItemCode",
        class: "smallwidth",
      },
      {
        header: "Code",
        field: "ItemProductId",
        class: "smallwidth",

      },
      {
        header: "Name",
        field: "Itemname1",
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: "Brand / Model /Size",
        field: "",
        slot: "Brandmodelsize",
        fieldDisplay: "false",
      },
      {
        header: "Avl Qty",
        field: "StockInHand",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: "Reorder level",
        field: "ReOrderLevel",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: "Qty",
        field: "ItemQuantity",
        bodyclass: "right_td",
        class: "smallwidth",
        slot: "quantity"
      },
      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "last-column-position columnfreeze",
        fieldDisplay: "false",
      },
    ];

    onMounted(() => {
      formloader.value=true;
      debugger;
      if (EditRequestId) {
        display.value = false;
        IsEdit();
        // if (IsApproval.value == 1) {
        //   getApprovaldata()
        // }
      } else {
      }
      window.addEventListener('scroll', handleScroll);
      formloader.value=false;
    });
    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll);
    });
    const paramValue = computed(() => {
      return route.query.param as string;
    });

    /*Method Defintion*/
    function storeUpdate(data) {
      debugger;
      commonItemProps.value.storeId = data.FromStore;
      commonItemProps.value.tostoreId = data.ToStore ?? 0;
      commonItemProps.value.FromStoreBrMapId = data.FromStoreBrMapId
      commonItemProps.value.ToStoreBrMapId = data.ToStoreBrMapId
      commonItemProps.value.StoreBrMapId = data.StoreBrMapId
    }

    //Item Edit
    function IsItemEdit(data) {
      debugger;
      dataItems.value = {};
      dataItems.value = data;
      dataItems.value["IsEdit"] = 1;
      dataItems.value["IsRequest"] = 1;
      displayClass.value = "show";
      scrollToTop()
    }
    let deleteditemlist: any = ref([])
    //Item Delete
    async function IsItemDelete(data) {
      debugger;
      let msg = null;
      if (data["IndentTemplateDetailsId"] && data["IndentTemplateDetailsId"] != 0) {
        deleteditemlist.value.push(data.IndentTemplateDetailsId)
      }
      if (msg == null) {
        items.value = items.value.filter(
          (item) =>
            item["ItemId"] !== data.ItemId ||
            (data.ModelNumber !== undefined &&
              item["ModelNumber"] !== data.ModelNumber) ||
            (data.Size !== undefined && item["Size"] !== data.Size) ||
            (data.Brand !== undefined && item["Brand"] !== data.Brand)
        );
      }
      console.log(items.value);
    }

    const IsSubmit = handleSubmit(async (values) => {
      debugger;
      if (items.value.length == 0) {
        toast.add({
          severity: "warn",
          summary: "Please Add the Item",
          detail: "",
          life: 3000,
        });
        return false;
      }
      else {
        loading.value = true
        console.log(requestData.value);
        Object.keys(requestData.value).forEach((key) => {
          if (requestData.value[key])
            requestForm.value[key] = requestData.value[key];
        });
        Object.keys(requestForm.value).forEach((key) => {
          if (storeForm.value[key])
            requestForm.value[key] = storeForm.value[key];
        });
        console.log(requestForm.value);
        requestForm.value.CreatedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        requestForm.value.ModifiedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        requestForm.value.BranchId = Number(routes.query.BranchId ?? 0);
        requestForm.value.HospitalId = HospitalId;
        requestForm.value.ModifiedBy = UserId;
        requestForm.value.CreatedBy = UserId;
        requestForm.value.Remarks.length != 0 ? requestForm.value.Remarks = requestForm.value.Remarks : requestForm.value.Remarks;
        requestForm.value.EntityId = Number(Entitydata.value);
        requestForm.value.DocDate = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        requestForm.value.StoreId = requestForm.value.FromStore;
        requestForm.value.EntityOperationId = OperationId;
        requestForm.value.DeptRoleId = rolesData.DeptRoleMapId;

        requestForm.value.StoreBrMapId = Number(StoreBrMapId);
        requestForm.value.FromStoreBrMapId = Number(StoreBrMapId);
        requestForm.value.FromStoreBranchId = Number(routes.query.BranchId ?? 0);

        requestForm.value.FromStore = Number(StoreId);
        requestForm.value.StoreId = Number(StoreId);

        let result: any;
        let msg: String = "";
        let id: any = 0;
        if (EditRequestId) {
          requestForm.value.Id = EditRequestId;
          result = await commonService.updateIndentTemplate(requestForm.value);

          if (result["result"] == "Already" && result["ErrorInfo"].ErrorCode == null) {
            toast.add({
              severity: "warn",
              summary: "Warning",
              detail: "Template name already exists",
              life: 3000,
            });
            loading.value = false
            return;
          }
          else {
            id = EditRequestId;
          }
        } else {
          result = await commonService.createIndentTemplate(requestForm.value);

          if (result["result"] == "Already" && result["ErrorInfo"].ErrorCode == null) {
            toast.add({
              severity: "warn",
              summary: "Warning",
              detail: "Template name already exists",
              life: 3000,
            });
            loading.value = false
            return;
          }
          else {
            id = result["result"];
          }

        }

        let message = result["ErrorInfo"].ErrorCode;
        if (result["result"] != "Already" && message == null) {
          debugger;
          for (let i = 0; i < items.value.length; i++) {
            let obj = {};
            (obj["ItemId"] = items.value[i]["ItemId"]),
              (obj["Qty"] = items.value[i]["ItemQuantity"]),
              (obj["RefId"] = id),
              (obj["PackSizeId"] = items.value[i]["PackSizeId"]),
              (obj["HSNId"] = items.value[i]["HSNId"]),
              (obj["UnitRate"] = items.value[i]["UnitRate"]),
              (obj["Rate"] = items.value[i]["Rate"]),
              (obj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
              (obj["ModifiedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
              (obj["CreatedBy"] = UserId),
              (obj["ModifiedBy"] = UserId),
              (obj["Id"] = items.value[i]["IndentTemplateDetailsId"]),
              (obj["AutoRequestId"] = items.value[i]?.["AutoRequestId"] || 0);
            (obj["Brand"] =
              items.value[i]["Brand"] == null ? 0 : items.value[i]["Brand"]),
              (obj["ModelNumber"] =
                items.value[i]["ModelNumber"] == null
                  ? 0
                  : items.value[i]["ModelNumber"]),
              (obj["Size"] =
                items.value[i]["Size"] == null ? 0 : items.value[i]["Size"]);
            // (obj["FromApproval"] = IsApproval.value || 0);
            (obj["FromApproval"] = 0);
            (obj["UOM"] = items.value[i]["UOM"])
            arr[i] = obj;
          }
          let result = await commonService.createIndentTemplateDetails(arr);
          let msgMapping = result["ErrorInfo"].ErrorCode;
          if (deleteditemlist.value.length != 0) {
            for (let item of deleteditemlist.value) {
              let Deleteresult = await commonService.deleteIndentTemplateDetailsCustom(
                item
              );
              msg = Deleteresult["ErrorInfo"].ErrorCode;
            }
          }

          // if (msgMapping == null && IsApproval.value != 1) {
          if (msgMapping == null) {
            if (EditRequestId) {
              loading.value = false

              popup.value.updatepop = true;
            } else {
              loading.value = false

              popup.value.successpop = true;
            }
          }
        }
      }
    });

    const AddItems = (value) => {
      debugger;
      console.log(value);
      items.value = value;
      pocalculation();
    };
    watch(items, (newItems, oldItems) => {
      debugger;
      // if (IsApproval.value == 1) {
      pocalculation();
      // }
    }, { deep: true });
    const pocalculation = () => {
      debugger;
      POCalcDetailsClear()
      for (let i = 0; i < items.value.length; i++) {
        POCalcDetails.value.GrossAmount += Number(items.value[i]["Rate"]);
      }
      poSubcalculation()
    };

    const poSubcalculation = () => {
      debugger;
      POCalcDetails.value.ItemCount = items.value.length;
      POCalcDetails.value.TotalAmount = Number((Number(POCalcDetails.value.GrossAmount)).toFixed(2));
      // approvaldetails.value.ApprovalPrice = POCalcDetails.value.TotalAmount;
    }

    function POCalcDetailsClear() {
      debugger;
      POCalcDetails.value.GrossAmount = 0.00;
      POCalcDetails.value.ItemCount = 0;
      POCalcDetails.value.TotalAmount = 0.00;
    }

    //Edit
    async function IsEdit() {
      debugger;
      SubmitBtnName.value = t("btn.update")
      let result = await commonService.GetByIndentTemplateId(EditRequestId);
      debugger
      let data = result["result"];

      items.value = result["result"];

      requestData.value.DocNo = result["result"][0].DocNo;
      requestForm.value.TemplateName = result["result"][0].TemplateName;

      Object.keys(requestForm.value).forEach((key) => {
        if (data[0][key]) requestForm.value[key] = data[0][key];
      });

      console.log(storeForm.value);
    }

    function ClosewariningPopup() {
      debugger;
      wariningPopup.value = false;
    }

    function CopyReorderData(selectValue) {
      debugger;

      let dataArray: any = [];
      dataArray = JSON.parse(JSON.stringify(items.value));
      let selectedArray: any = [];
      let checkArray =
        selectValue == "All" ? ReOrderData.value : selectedProduct.value;
      selectedArray = JSON.parse(JSON.stringify(checkArray));
      dataArray.map((item: any) => {
        const item2 = selectedArray.find(
          (data: any) => data.ItemId == item.ItemId
        );
        if (item2) {
          item.ItemQuantity =
            parseInt(item.ItemQuantity) + parseInt(item2.ItemQuantity);
        }
      });

      console.log(items.value);

      let arr1: any = [];

      arr1 = selectedArray.filter(
        (value) => !dataArray.some((i1) => i1.ItemId == value.ItemId)
      );

      for (let i = 0; i < arr1.length; i++) {
        dataArray.push(arr1[i]);
      }
      items.value = dataArray;
      dataItems.value = items.value;
      selectedProduct.value = null;
      ReOrderData.value = ReOrderData.value.filter(
        (value) => !selectedArray.some((i1) => i1.ItemId == value.ItemId)
      );
      AddItemmodel.value = false;
      ItemTab.value = "show";
    }

    function closetrigger() {
      setupHistoryManagement(router, 2);

    }

    function deleteclosetrigger() {
      debugger;
    }

    const ParameterValues = ref({ Id: 0 });
    const PrintType = ref({ Type: "S", FormId: 9, ModuleId: 3 });
    let isForm = ref({
      EntityOperationId: 0,
      Id: 0,
      EntityApprovalMapID: 0,
      EntityTransactionId: 0,
      ApproverID: UserId,
      DepRoleID: rolesData.DeptRoleMapId,
      IsApproved: 0,
      ApprovedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      Remarks: "",
    });
    function LineItemCalculation(data) {
      debugger
      data.Rate = data.ItemQuantity * data.UnitRate
      pocalculation()
    }
    const isVisible = ref(false);
    const handleScroll = () => {
      isVisible.value = window.scrollY > 300; // Show button after scrolling 300px
    };
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    };
    const Itemschanges = (value) => {
      debugger;
      if (value != "") {
        items.value = []
        items.value = value;
      }
    };
    return {
      Itemschanges,
      isVisible,
      scrollToTop,
      SuccessfullPopUp,
      ApprovalListchange,
      ApprovalList,
      TblIndex,
      RequestOPT,
      showitemfield,
      items,
      headers,
      loading,
      paramValue,
      storeForm,
      requestForm,
      IsSubmit,
      AddItems,
      showFields,
      IsItemEdit,
      dataItems,
      IsItemDelete,
      display,
      displayClass,
      fieldData,
      popup,
      requestData,
      closetrigger,
      formloader,
      ReOrderData,
      ReOrderheaders,
      selectedProduct,
      CopyReorderData,
      AddItemmodel,
      confirmval,
      deleteclosetrigger,
      wariningPopup,
      ClosewariningPopup,
      msgcontent,
      warningmsgcontent,
      ItemTab,
      StoreDetailsData,
      commonItemProps,
      storeUpdate,
      Entitydata,
      CrystalReportPopup,
      ParameterValues,
      PrintType,
      status,
      POCalcDetails,
      LineItemCalculation,
      SubmitBtnName
    };
  },
});
</script>
<style lang="scss">
/* .white-blue-border */

.transactiontabs .p-tabview .p-tabview-panels {
  margin-top: 0 !important;
}
</style>
